/* pk-addon.js: the simple product page (sections/pk-addon-main). Vanilla; the form posts to /cart/add without it.
   - amount / option chips update the hidden variant id, the price and the button (sold-out variants are disabled)
   - with the Pakks cart drawer (window.PakksCart) the add happens in place and the drawer opens; otherwise the normal form post. */
(function () {
  if (window.__pkAddon) return; window.__pkAddon = true;
  function init(root) {
    (root || document).querySelectorAll('[data-pk-addon-form]').forEach(function (form) {
      if (form.__pk) return; form.__pk = true;
      var idIn = form.querySelector('[data-pk-addon-id]'), btn = form.querySelector('[data-pk-addon-atc]'), price = form.querySelector('[data-pk-addon-price]'), status = form.querySelector('[data-pk-addon-status]');
      form.querySelectorAll('[data-pk-addon-variant]').forEach(function (r) {
        r.addEventListener('change', function () {
          if (!r.checked) return;
          idIn.value = r.value;
          if (price) price.textContent = r.getAttribute('data-price');
          var ok = r.getAttribute('data-available') === 'true';
          btn.disabled = !ok; btn.textContent = ok ? btn.getAttribute('data-label') : btn.getAttribute('data-soldout');
          if (window.history && history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', r.value); history.replaceState(null, '', u); }
        });
      });
      form.addEventListener('submit', function (e) {
        if (!window.PakksCart || !window.PakksCart.add) return;
        e.preventDefault();
        btn.setAttribute('aria-busy', 'true');
        window.PakksCart.add({ id: +idIn.value, quantity: 1 }, { open: true }).then(function () {
          if (status) status.textContent = btn.getAttribute('data-label') + ': done';
        }).catch(function () { form.submit(); }).then(function () { btn.removeAttribute('aria-busy'); });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
